import React from 'react';
import { css } from '@emotion/core';

export default ({ isTransparent }) => (
    <div css={containerStyle}>{!isTransparent && <div css={IconStyle} />}</div>
);

const containerStyle = css`
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 88888;
`;

const IconStyle = css`
    margin: auto;
    position: fixed;
    height: 106px;
    width: 106px;
    background-image: url(https://assets.fevercdn.com/promotion/img/loading-ellipsis.svg);
    background-repeat: no-repeat;
    z-index: 88888;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    &:before {
        content: '';
        height: 100%;
        width: 100%;
    }
`;
